 $(document).ready(function(){
      $('.city').hide();
      $('.block').on('click', function(){
        $('.block').removeClass('active');
        $(this).addClass('active');
        var targetCityId = $(this).data('target');
        $('.city').hide();
        $('#' + targetCityId).show();
      });
    });
$(document).ready(function() {
  $('.data-flower').on('click', function() {
    $('.data-flower').removeClass('active');
    $(this).addClass('active');
    var parent = $(this).closest('.data-flower');
    var header = parent.data('header');
    var paragraph = parent.data('pharghraph');
    var button = parent.data('button');
    var number = parent.data('number');
    var link = parent.data('link');
    var time = parent.data('time');
    $('.first-add .flower-heading').text(header);
    $('.first-add .flower-pharaghraph').text(paragraph);
    $('.first-add .flower-button').text(button);
    $('.first-add .flower-Phone').text(number);
    $('.first-add .flower-link').attr('href', link);
    $('.first-add .flower-timer').text(time);
  });
});
$(document).ready(function() {
  $('.data-flower-sec').on('click', function() {
    $('.data-flower-sec').removeClass('active');
    $(this).addClass('active');
    var parent = $(this).closest('.data-flower-sec');
    var header = parent.data('header');
    var paragraph = parent.data('pharghraph');
    var button = parent.data('button');
    var number = parent.data('number');
    var link = parent.data('link');
    var time = parent.data('time');
    $('.second-add .flower-heading').text(header);
    $('.second-add .flower-pharaghraph').text(paragraph);
    $('.second-add .flower-button').text(button);
    $('.second-add .flower-Phone').text(number);
    $('.second-add .flower-link').attr('href', link);
    $('.second-add .flower-timer').text(time);
  });
});
$(document).ready(function() {
  $('.data-flower-third').on('click', function() {
    $('.data-flower-third').removeClass('active');
    $(this).addClass('active');
    var parent = $(this).closest('.data-flower-third');
    var header = parent.data('header');
    var paragraph = parent.data('pharghraph');
    var button = parent.data('button');
    var number = parent.data('number');
    var link = parent.data('link');
    var time = parent.data('time');
    $('.third-add .flower-heading').text(header);
    $('.third-add .flower-pharaghraph').text(paragraph);
    $('.third-add .flower-button').text(button);
    $('.third-add .flower-Phone').text(number);
    $('.third-add .flower-link').attr('href', link);
    $('.third-add .flower-timer').text(time);
  });
});

  $(document).ready(function() {
  $('.data-flower-four').on('click', function() {
    $('.data-flower-four').removeClass('active');
    $(this).addClass('active');
    var parent = $(this).closest('.data-flower-four');
    var header = parent.data('header');
    var paragraph = parent.data('pharghraph');
    var button = parent.data('button');
    var number = parent.data('number');
    var link = parent.data('link');
    var time = parent.data('time');
    $('.fourth-add .flower-heading').text(header);
    $('.fourth-add .flower-pharaghraph').text(paragraph);
    $('.fourth-add .flower-button').text(button);
    $('.fourth-add .flower-Phone').text(number);
    $('.fourth-add .flower-link').attr('href', link);
    $('.fourth-add .flower-timer').text(time);
  });
});

